// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"366":"d533a9aa","594":"acc4db9a","830":"4206273d"}[chunkId] + ".css";
};